module.exports = __webpack_public_path__ + "img/glm_gbt6175_2000.prt.500b10b3.jpg";